//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountPlanPerks",
  props: {
    plan: {
      type: Object,
      required: true
    },
    perks: {
      type: Boolean,
      default: true
    },
    missingPerks: {
      type: Boolean,
      default: true
    }
  }
});